export default "__VITE_PUBLIC_ASSET__ffc41e5c__"